/* global imagesLoaded */
export default class MasonryFilters {
	constructor(filters) {
		if ( ! filters ) return;

		this.filters = filters
		this.listingWrapper = document.querySelector( '.listing-wrapper' )
		this.listingWrapperIsotope = null
		this.filterLinks = this.filters.querySelectorAll( 'a' ); //imageWrappers

		this.activeFilter = this.filters.querySelector( '.active' ).dataset.filter
		this.init();
		this.events();
	}

	init() {
		imagesLoaded(this.listingWrapper).on('progress', () => {
			this.listingWrapperIsotope = new Isotope(
				document.querySelector( '.listing-wrapper' ),
				{
					itemSelector: 'article',
				}
			)
		})
	}

	onFilterLinkClicked(ev) {

		this.activeFilter = ev.target.dataset.filter

		this.listingWrapperIsotope.arrange(
			{
				filter: this.activeFilter
			}
		)
	}

	events() {
		this.filterLinks.forEach( el => el.addEventListener('click', this.onFilterLinkClicked.bind(this), false))
	}
}
